import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import { Input, List } from "antd";
import { useState } from "react";
import { searchCollection } from "../../api/Search";
import CollectionCard from "./CollectionCard";

const SearchCollection = (props) => {
  const { type, onClickAdd, renderType } = props;

  const [searchInput, setSearchInput] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [isLoading, setIsloading] = useState(false);

  const loadData = async (input) => {
    if (input.length > 0) {
      setIsloading(true);
      const res = await searchCollection(input);
      if (res) setSearchResult(res.collections);
      setIsloading(false);
    }
  };

  const handleChange = async (e) => {
    setSearchInput(e.target.value);
    loadData(e.target.value);
  };

  const renderCard = (serie) => {
    return (
      <CollectionCard
        serie={serie}
        type={type || "default"}
        onClickAdd={onClickAdd}
      />
    );
  };

  const renderList = (serie) => {
    return (
      <List.Item
        key={serie.id}
        actions={[
          <PlusOutlined
            onClick={() => {
              if (onClickAdd) onClickAdd(serie);
            }}
            key="add"
          />,
        ]}
      >
        {serie.name}
      </List.Item>
    );
  };

  return (
    <>
      <Input
        allowClear
        addonBefore={<SearchOutlined />}
        onChange={handleChange}
        placeholder="Rechercher une série"
        value={searchInput}
      />
      <div
        id="scrollableDiv"
        style={{
          ...(renderType === "list" && { height: 200 }),
          overflow: "auto",
          padding: "0 16px",
        }}
      >
        <List
          style={{ marginTop: 20 }}
          size="small"
          loading={isLoading}
          {...(renderType === "card" && { grid: { column: 3 } })}
          // grid={{ column: 3 }}
          dataSource={searchResult}
          renderItem={renderType === "card" ? renderCard : renderList}
        />
      </div>
    </>
  );
};
export default SearchCollection;
